<script setup lang="ts">
import small from './small.vue'
import standard from './standard.vue'
import medium from './medium.vue'
import large from './large.vue'
import xlarge from './xlarge.vue'
import { IconColors, IconPosition, IconSizes } from '@temperworks/types'
const props = defineProps<{
  size: IconSizes
  fill: IconColors
  position: IconPosition
}>()
const sizes : { [key: string]: any } = {
  small,
  standard,
  medium,
  large,
  xlarge,
}
</script>
<template>
  <component
    :is="sizes[props.size]"
    :class="[props.position, props.fill]"
  />
</template>
